// Pick an on-screen slogan (admin-defined, weighted) for a scoring event, and
// map each event kind to a neon burst colour. Goon puns per base imagery.
import type { Slogan, SloganKind } from '../types'

const FALLBACKS: Record<SloganKind, string[]> = {
  hit: ['EDGED!', 'PUMP!', 'STROKE!', 'GLAZED', 'LEAK'],
  bonus: ['TEASED', 'DENIED', 'LEAKING'],
  combo: ['GOONING', 'FULL SEND', 'STROKING'],
  milestone: ['FLIFFER!', 'FULL LOAD', 'CUMMING THRU', 'GOONED'],
}

export const SPLASH_COLORS: Record<SloganKind, string> = {
  hit: '#ff2d9b',
  bonus: '#22e8ff',
  combo: '#c026ff',
  milestone: '#ff1a3a',
}

/** Weighted random pick of an enabled slogan of the given kind. */
export function pickSlogan(slogans: Slogan[], kind: SloganKind): string {
  const pool = slogans.filter((s) => s.enabled !== false && s.kind === kind && s.text.trim())
  if (!pool.length) {
    const fb = FALLBACKS[kind]
    return fb[Math.floor(Math.random() * fb.length)]
  }
  const total = pool.reduce((n, s) => n + Math.max(1, s.weight), 0)
  let r = Math.random() * total
  for (const s of pool) {
    r -= Math.max(1, s.weight)
    if (r <= 0) return s.text
  }
  return pool[pool.length - 1].text
}
